package com.eladfinish.bible.contest.features.verseWidget

/**
 * What happened in this run of the app (not saved: a new launch starts it over) that decides whether the hint on the
 * random-verse screen may appear. One instance for the whole app.
 *
 * Two messages never share a session, and the hint is the later one: the one-time "what's new" sheet and the review
 * request call [onOtherPromptShown] when they go out, and the hint then waits for another launch.
 */
class VerseWidgetPromptSession {

    /** How many verses the random-verse screen has shown since the app was launched, across its visits. */
    var versesViewed: Int = 0
        private set

    var isOtherPromptShown: Boolean = false
        private set

    fun onVerseViewed() {
        versesViewed++
    }

    /** The sheet that introduces the widget, a review request or any other message of the app went out. */
    fun onOtherPromptShown() {
        isOtherPromptShown = true
    }
}
